export const paginationResponseParse = ({ response, pagination, dispatch, duckActions, setPagination }) => {
  if (response?.items?.length === 0 && pagination?.offset && pagination.offset !== 1) {
    const paginationData = { ...pagination, offset: Math.ceil(response.count / pagination.limit) };
    if (setPagination) setPagination(paginationData);
    else if (dispatch && duckActions && duckActions.setPagination) dispatch(duckActions.setPagination(paginationData));
  }
};
